import React, { MouseEventHandler, useState } from 'react';
import styled from 'styled-components';
import AttendanceDetailViewController from './AttendanceDetail/AttendanceDetailViewController';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const Container = styled.article`
  color: #161d1f;

  .divider-block {
    margin-top: 16px;
    margin-bottom: 16px;
    background: #8090bb;
    height: 1px;
    gap: 0px;
    opacity: 0px;
  }
  .title {
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    margin-bottom: 8px;
  }
  .subtitle {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    margin-bottom: 16px;
  }
  .button {
    width: Fill (134px) px;
    height: Hug (44px) px;
    padding: 12px 24px 12px 24px;
    gap: 10px;
    border-radius: 4px;
    border: 1px;
    opacity: 0px;
    border: 1px solid #5b36f2;
    //styleName: Button/Button 01;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    color: #5b36f2;
    width: 100%;

    &:hover {
      background: #e2dffd;
    }

    &:focus,
    &:active {
      background: #c6c0fc;
    }

    //media query
    @media (min-width: 640px) {
      width: auto;
    }
  }
`;

interface AttendanceBlockProps {
  courseTitle: string;
  catalogNumber: string;
  sectionId: string;
  selectPeriod: string;
}
const AttendanceBlock = ({
  courseTitle,
  catalogNumber,
  sectionId,
  selectPeriod
}: AttendanceBlockProps) => {
  const [showAttendance, setShowAttendance] = useState(false);

  const handleAttendance: MouseEventHandler<HTMLButtonElement> = (e) => {
    GoogleAnalytics.writeLog('portal-course-showAssistance', 'course');
    (e.target as any).blur();
    (e.target as any).parentElement.blur();
    setShowAttendance(!showAttendance);
  };

  return (
    <Container>
      <hr className="divider-block" />
      <div className="title">Registro de asistencia</div>
      <div className="subtitle">
        Conoce el detalle de tu asistencia al curso.
      </div>

      <button onClick={handleAttendance} type="button" className="button">
        Ver asistencia
      </button>
      {showAttendance && (
        <AttendanceDetailViewController
          setShowAttendance={setShowAttendance}
          courseTitle={courseTitle}
          catalogNumber={catalogNumber}
          sectionId={sectionId}
          selectPeriod={selectPeriod}
        />
      )}
    </Container>
  );
};

export default AttendanceBlock;
